module.exports = __webpack_public_path__ + "static/media/29ADMSPC39.4c775010.jpg";